import { Select } from "src/base-components/Select";
import {
  COLORS,
  Color,
  castColor,
} from "src/base-components/schemaKit/schemaColors";
import { LegendIcon } from "src/design-system/LegendIcon";
import { type LegendIconColor } from "src/design-system/utils/colorPalette";

const toIconColor = (colorClassName: string): LegendIconColor =>
  colorClassName.replace("text-", "") as LegendIconColor;

const colorOptions = Object.entries(COLORS).map(([color, className]) => ({
  key: color,
  value: (
    <div className="w-4">
      <LegendIcon color={toIconColor(className)} size="3xs" />
    </div>
  ),
}));

type ColorSelectorProps = {
  value: Color | null | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const ColorSelector: React.FC<ColorSelectorProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <Select
    dataLoc="color-selector"
    disabled={disabled}
    options={colorOptions}
    value={castColor(value)}
    fullWidth
    onChange={onChange}
  />
);
